import { useContext } from "react";
import { AuthenticationContext } from "contexts";

export function useAuthentication() {
  const {
    user,
    login,
    logout,
    cambiarCompania,
    volverCompaniaOriginal,
    refrescarSesion,
    pending2FA,
    verify2fa,
    resend2fa,
    cancelar2FA,
  } = useContext(AuthenticationContext);

  const tienePermiso = (permiso) => {
    return user.Funciones.includes(permiso);
  };

  return {
    usuario: user,
    login,
    logout,
    cambiarCompania,
    volverCompaniaOriginal,
    refrescarSesion,
    tienePermiso,
    pending2FA,
    verify2fa,
    resend2fa,
    cancelar2FA,
  };
}
